import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '../../../../../infrastructure/logging/logger';
import { UserContextProvider } from '../../../../../infrastructure/context/user-context-provider';
import { DetailPair } from '../../../../../shared/components/detail-info-card/DetailPair';
import { formatCurrencyString } from '../../../../../utilities/CurrencyUtility';
import { DetailInfoCardComponent } from '../../../../../shared/components/detail-info-card/detail-info-card.component';

@Component({
  selector: 'app-policy-info',
  templateUrl: './policy-info.component.html',
  styleUrls: ['./policy-info.component.scss'],
  standalone: true,
  imports: [
    DetailInfoCardComponent
  ]
})
export class PolicyInfoComponent implements OnInit {

  @Input() policy: any;

  policyInfo: DetailPair[] = [];
  policyId!: any;

  constructor(
    private router: Router,
    private logService: Logger,
    private userContextProvider: UserContextProvider
  ) { }

  ngOnInit() {
    this.populatePolicyInfo(this.policy);
  }

  async populatePolicyInfo(policy: any) {
    try {
      this.policyInfo = [];

      let statusText;
      if (policy.status_id === 1) {
        statusText = "Active";
      }
      if (policy.status_id === 2) {
        statusText = "Inactive";
      }

      let allCountriesText;
      if (policy.all_countries === 1) {
        allCountriesText = "Yes";
      }
      if (policy.all_countries === 2) {
        allCountriesText = "No";
      }

      this.policyInfo.push(new DetailPair("Policy ID", policy.id));
      this.policyInfo.push(new DetailPair("Status", statusText));
      this.policyInfo.push(new DetailPair("Currency", policy.currency.code));
      this.policyInfo.push(new DetailPair("Average Nightly Rate", `${formatCurrencyString(policy.range_reservation_price_from, this.userContextProvider.currencyCode)} - ${formatCurrencyString(policy.range_reservation_price_to, this.userContextProvider.currencyCode)}`));
      this.policyInfo.push(new DetailPair("Number Of Guests", `${policy.range_guests_from} - ${policy.range_guests_to}`));
      this.policyInfo.push(new DetailPair("Number Of Bedrooms", `${policy.range_no_of_bedrooms_from} - ${policy.range_no_of_bedrooms_to}`));
      this.policyInfo.push(new DetailPair("Contents Coverage", formatCurrencyString(policy.damage_coverage, this.userContextProvider.currencyCode)));
      this.policyInfo.push(new DetailPair("Liability Coverage", formatCurrencyString(policy.liability_coverage, this.userContextProvider.currencyCode)));
      this.policyInfo.push(new DetailPair("Dwelling Coverage", formatCurrencyString(policy.dwelling_coverage, this.userContextProvider.currencyCode)));
      this.policyInfo.push(new DetailPair("Description", policy.description));
      this.policyInfo.push(new DetailPair("Note", policy.note));
      this.policyInfo.push(new DetailPair("Available For All Countries", allCountriesText));
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while populating Organization info', 'Error while populating Organization info');
    }
  }

  onEditPolicyInfoClick() {
    this.router.navigate(['/policies/form'], { queryParams: { policyId: this.policyId } });
  }
}